import { Component, Input, OnInit } from '@angular/core';
import { apiService } from '../../service/api.service';
import { ResponseJardinModel, JardinModel} from '../../model/Jardin.model'
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ModalCambiarPassComponent } from '../jardin/components/dialogs/modal-cambiar-pass/modal-cambiar-pass.component'
import { StorageService } from 'src/app/service/storage.service';
import { EncargadaModel, ResponseEncargadaModel } from 'src/app/model/Identificacion.model';
import { ModalCambiarFotoperfilComponent } from './components/dialogs/modal-cambiar-fotoperfil/modal-cambiar-fotoperfil.component';
import { ReglamentoInternoModel } from 'src/app/model/ReglamentoInterno.model';


@Component({
  selector: 'app-jardin',
  templateUrl: './jardin.component.html',
  styleUrls: ['./jardin.component.css']
})
export class JardinComponent implements OnInit {
  @Input() simulacion: boolean;
  idUsuario='';
  datosDirec = new EncargadaModel();
  menuMostrar : string;
  jardin = new JardinModel(); 
  direccionar : Subscription;
  cargando = true;
  mostrarPME : boolean = false;
  urlProfile = '';
  constructor(  
    public api: apiService, 
    public dialog: MatDialog,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.direccionar = this.api.getEmitDireccionamiento().subscribe((respuesta:string)=>{
      this.menuVisible(respuesta)
    });
    this.idUsuario = this.storageService.getCurrentUser().idUsuario.toString();
    this.getFotoPerfil();
    this.getJardin(this.idUsuario);
    this.menuMostrar = this.storageService.getMenuActivo() != null ? this.storageService.getMenuActivo() : 'inicio' ;


  }

  ngOnDestroy(): void {
    this.direccionar.unsubscribe();
  }

  getJardin(id) {
    if(this.simulacion){
      this.jardin =  this.api.dataJardin;
      this.getDirectora(this.jardin);
    }else{
      this.api.API_POST_obtenerJardin(id).subscribe((response:ResponseJardinModel) => {
        this.api.dataJardin = response.payload;
        this.jardin = response.payload;

        if(this.jardin.tipoJardin == 'Alternativo'){
          this.mostrarPME = true;
        }
        
        this.getDirectora( this.jardin);
      },
      (err) => { 
        console.log(err)
      })
      
      this.api.API_POST_obtenerJardin2023(id).subscribe((response:ResponseJardinModel) => {
        this.api.dataJardin2023 = response.payload;
        this.jardin = response.payload;
        this.getDirectora( this.jardin);
      },
      (err) => { 
        console.log(err)
      })

      this.api.API_POST_obtenerJardin2024(id).subscribe((response:ResponseJardinModel) => {
        this.api.dataJardin2024 = response.payload;
        this.jardin = response.payload;
        this.getDirectora( this.jardin);
      },
      (err) => { 
        console.log(err)
      })

      this.api.API_POST_obtenerJardin2025(id).subscribe((response:ResponseJardinModel) => {
        this.api.dataJardin2025 = response.payload;
        this.jardin = response.payload;
        this.getDirectora( this.jardin);
      },
      (err) => { 
        console.log(err)
      })

    }
    
}

getDirectora(dataJardin:JardinModel){
  this.api.API_POST_obtenerDirectora(dataJardin.id).subscribe((response: ResponseEncargadaModel) => {
    this.datosDirec = response.payload;
    this.cargando = false;
  },
  (err) => {
    console.log(err)
  })
}


getFotoPerfil() {
  this.api.API_POST_obtenerFotoPerfil(this.idUsuario).subscribe((response:any) => {
    if(response.payload != null){
      this.urlProfile = "data:image/jpg;base64,"+response.payload;
    }else{
      this.urlProfile = "../../../assets/JUNJI_avatar.svg";
    }
    
  },
  (err) => { 
    this.urlProfile = "../../../assets/JUNJI_avatar.svg";
    console.log(err)
  })
}

  menuVisible(item) {
    this.storageService.setMenuActivo(item);
    this.menuMostrar = this.storageService.getMenuActivo();
  }

  cambiarPass(){ 
    const dialogRef = this.dialog.open(ModalCambiarPassComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => {
      console.log('Mensaje desde la modal: '+result);      
      if(result=='refresh'){
      

      }
    });
  }

  cambiarFoto(){
    const dialogRef = this.dialog.open(ModalCambiarFotoperfilComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  

  cerrarSesion(){
    this.storageService.logout();
  }
}
